import { HeadTagsConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';

export function createHeadTagsConfig(): HeadTagsConfig {
  return {
    defaultTitle: 'eXp Realty®',
    defaultMetaDescriptionKey: LOCALE_EXP_REALTY_US_PATHS.HEAD_TAGS_DEFAULT_META_DESCRIPTION,
  };
}

